export default __webpack_public_path__ + "img/jpg/uses-cases-illustration.jpg";